import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type { CashReportRequestData, CashReportResponse } from "../../../../graphql/types"

export const fetchCashReportData = (
    headers: Record<string, any>,
    data: CashReportRequestData
): Promise<Maybe<CashReportResponse>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query cashReport($data: CashReportRequestData!) {
                  cashReport(data: $data) {
                    data {
                        accountName
                        amount
                        assigneeName
                        currency
                        endBalance
                        locationName
                        orderNumber
                        payInPayOut
                        receivedOn
                        terminalName
                        transactionNumber
                        transactionType
                        operation                 
                    }
                    totalCount
                  }
                }
                
            `,
            operationName: "cashReport",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.cashReport) {
            return response.data.cashReport
        }

        return null
    })
